// extracted by mini-css-extract-plugin
export default {"content":"HuntsPage_content__Wmfgg","no-hunt":"HuntsPage_no-hunt__IEeHV","footer":"HuntsPage_footer__C7Y5w"};